import {ShareForm} from '../shared-modal/share-form/models/share.form';

export abstract class SharedServiceInterface {

  abstract sendSharedLinkViaEmail(uid: string, form: ShareForm): Promise<void>;

}
